import { mediaUrl, useFetch, useTitle } from "../lib";
import { PageHeader, SampleTag, Empty, Reveal } from "../ui";

function Player({ v }) {
  const src = mediaUrl(v.media_id);
  if (!src)
    return (
      <div className="aspect-video bg-[#2A2623] text-lou-paper/80 flex flex-col items-center justify-center text-center p-8" data-testid={`video-placeholder-${v.id}`}>
        <SampleTag show={v.is_sample} />
        <p className="font-lou italic text-2xl mt-3">The recording will appear here</p>
        <p className="text-sm mt-2 opacity-70">It will never play on its own. Press play when you're ready.</p>
      </div>
    );
  if (v.kind === "audio") return <audio src={src} controls preload="metadata" className="w-full" data-testid={`audio-${v.id}`} />;
  return (
    <video controls preload="metadata" playsInline poster={mediaUrl(v.poster_media_id) || undefined}
      className="w-full bg-black" data-testid={`video-${v.id}`} crossOrigin="anonymous">
      <source src={src} type={v.content_type || "video/mp4"} />
      {v.captions_media_id && <track kind="captions" srcLang="en" label="English" src={mediaUrl(v.captions_media_id)} default />}
    </video>
  );
}

export default function Motion() {
  useTitle("Louise in Motion");
  const { data } = useFetch("/videos");
  return (
    <div data-testid="motion-page">
      <PageHeader eyebrow="Louise in Motion" title="Her voice, her kitchen, her way" />
      <div className="max-w-5xl mx-auto px-6 lg:px-10 space-y-28">
        {data && data.length === 0 && <Empty testid="motion-empty">Recordings will be added by the family.</Empty>}
        {(data || []).map((v) => (
          <Reveal key={v.id}>
            <article data-testid={`motion-item-${v.id}`}>
              <Player v={v} />
              <div className="grid md:grid-cols-3 gap-10 mt-8">
                <div className="md:col-span-2">
                  <h2 className="font-lou text-3xl sm:text-4xl font-light">{v.title}</h2>
                  {v.downloadable && (
                    <a href={`${mediaUrl(v.media_id)}?download=1`} className="lou-btn inline-flex mt-5 !py-2 text-sm" data-testid={`video-download-${v.id}`}>
                      Download MP4
                    </a>
                  )}
                  {v.intro && <p className="text-lou-soft mt-4 leading-relaxed whitespace-pre-line">{v.intro}</p>}
                  {v.transcript && (
                    <details className="mt-8 border-t border-lou-line pt-4" data-testid={`transcript-${v.id}`}>
                      <summary className="cursor-pointer text-sm tracking-wide">Read the transcript</summary>
                      <p className="mt-4 text-sm leading-relaxed whitespace-pre-line text-lou-soft">{v.transcript}</p>
                    </details>
                  )}
                </div>
                {v.recipe && (
                  <aside className="bg-lou-paper border border-lou-line p-6" data-testid={`recipe-${v.id}`}>
                    <p className="text-xs tracking-[0.2em] uppercase text-lou-clay">The recipe</p>
                    <p className="mt-3 text-sm leading-relaxed whitespace-pre-line">{v.recipe}</p>
                  </aside>
                )}
              </div>
              {v.related_media_ids?.length > 0 && (
                <div className="flex gap-3 mt-8 overflow-x-auto">{v.related_media_ids.map((m) => <img key={m} src={mediaUrl(m)} alt="" className="h-40 w-auto" loading="lazy" />)}</div>
              )}
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
